import React, { useEffect, useState } from 'react'
import { useGetQuestionsListQuery } from '../../API/QuestionApi';

import QuestionQueryTable from './QuestionQueryTable';
import { questionModel } from '../../Interfaces/questionModel';
import Loader from '../../Helper/Loader';
import { categoryModel } from '../../Interfaces/categoryModel';

function QuestionQuery() {
    const [filters, setFilters] = useState({ searchString: ""});
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageOptions, setPageOptions] = useState({
        pageNumber: 1,
        pageSize: 10,
    });
    const [currentPageSize, setCurrentPageSize] = useState(pageOptions.pageSize);
     const [loading, setLoading] = useState(false);
     const[fromInput, setFromInput] = useState({
         searchString:"",
          categoryId:0,
        subCategoryId:0,
        level:0,
    });
      const[input, setInput] = useState({
        searchString:"",
        categoryId:0,
        subCategoryId:0,
        level:0,
    });
    const{data, isLoading} = useGetQuestionsListQuery({
       ...(fromInput.categoryId ? { searchString: fromInput.categoryId } : {}),
        ...(fromInput.subCategoryId ? { searchString: fromInput.searchString } : {}),
         ...(fromInput.searchString ? { searchString: fromInput.searchString } : {}),
        ...(fromInput.searchString ? { searchString: fromInput.searchString } : {}),
       ...(pageOptions.pageSize
         ? { pageSize: pageOptions.pageSize } : {}),
        ...(pageOptions.pageNumber ? { pageNumber: pageOptions.pageNumber } : {}),
    });
     const [questionChoiceData, setQuestionChoiceData] = useState<questionModel[]>([]);
     const [categories, setCategories] = useState<categoryModel[]>([]);
     useEffect(() =>{
        setLoading(true);
        if(data?.result != null){
            console.log(data?.helperResult);
            setTotalRecords(data.totalCount);
            setQuestionChoiceData(data.result);
            setCategories(data?.helperResult);
        }
        setLoading(false);
    },[data])
     const handleFilter =() => {
          setFromInput({
          searchString:input.searchString,
          categoryId:input.categoryId,
          subCategoryId:input.subCategoryId,
          level:input.level,
        })
      

    }
     const handleUserInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
          const { name, value } = e.target;
          let processedValue: any = value;
          setInput((prev) => ({
            ...prev,
            [name]: processedValue
          }));
    };

    const getPageDetails = () => {
    const dataStartNumber =
      (pageOptions.pageNumber - 1) * pageOptions.pageSize + 1;
    const dataEndNumber = pageOptions.pageNumber * pageOptions.pageSize;

    return `${dataStartNumber}
             - 
            ${
              dataEndNumber < totalRecords ? dataEndNumber : totalRecords
            } of ${totalRecords}`;
  };

  const handlePageOptionChange = (direction: string, pageSize?: number) => {
    if (direction === "prev") {
      setPageOptions({ pageSize: currentPageSize, pageNumber: pageOptions.pageNumber - 1 });
    } else if (direction === "next") {
      setPageOptions({ pageSize: currentPageSize, pageNumber: pageOptions.pageNumber + 1 });
    } else if (direction === "change") {
      setPageOptions({
        pageSize: pageSize ? pageSize : 5,
        pageNumber: 1,
      });
    }
  };
  return (
    <div>
          <div className="row align-items-center mb-3">
              <div className="col-md-2 text-end" onClick={() => handleFilter()}>
                <button className='btn btn-secondary'>Advance Search</button>
              </div>
               <div className="col-md-2 text-end">
                  <input type="text" className="form-control" 
                   placeholder='type here'
                   name='searchString'
                   value={input.searchString}
                   onChange={handleUserInput}
                  />
              </div>
              <div className="col-md-2 text-end">
                    <select
                          required
                          className="form-control form-select"
                          name='categoryId'
                          value={input.categoryId}
                          onChange={handleUserInput}
                        >
                          <option value="">-=Select Categories=-</option>
                          {categories?.map((option: any, index: number) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                    </select>
              </div>
              <div className="col-md-2 text-end">
                    <select
                          required
                          className="form-controls form-select"
                          name='subCategoryId'
                          value={input.subCategoryId}
                          onChange={handleUserInput}
                        >
                        <option value="">-=Select Sub Categories=-</option>
                         {categories
                            .find((d) => d.id == input.categoryId) // 🔹 get the selected department
                            ?.subCategory?.map((option) => (      // 🔹 map its positions
                                <option key={option.id} value={option.id}>
                                {option.subCategoryName}
                                </option>
                            ))}
                    </select>
              </div>
               <div className="col-md-2 text-end">  
                    <select
                          required
                          className="form-control form-select"
                          name='level'
                          value={input.level}
                          onChange={handleUserInput}
                        >
                          <option value="">-=Level=-</option>
                            <option key={1} value={1}>
                              Easy
                            </option>
                             <option key={2} value={2}>
                              Medium
                            </option>
                             <option key={3} value={3}>
                              Hard
                            </option>
                            
                    </select>	
               </div>

              {/* <div className="col-md-2">
                  <input
                      type="date"
                      id="fromDate"
                      className="form-control datepicker"
                      name="fromDate"
                      value={input.fromDate ?? ""}
                      onChange={handleUserInput}
                  />
              </div> */}
             
          </div>

        { 
        !loading ? <QuestionQueryTable questionChoiceData={questionChoiceData}/>:<Loader/>
        }

           <div className="d-flex mx-5 justify-content-end align-items-center">
            <div>Rows per page: </div>
            <div>
              <select
                className="form-select mx-2"
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                  handlePageOptionChange("change", Number(e.target.value));
                  setCurrentPageSize(Number(e.target.value));
                }}
                style={{ width: "100px" }}
                value={currentPageSize}
              > 
                <option>10</option>
                 <option>20</option>
                <option>30</option>s
               
              </select>
            </div>
            <div className="mx-2">{getPageDetails()}</div>
            <button
              onClick={() => handlePageOptionChange("prev")}
              disabled={pageOptions.pageNumber === 1}
              className="btn btn-outline-primary px-3 mx-2"
            >
              <i className="bi bi-chevron-left"></i>
            </button>
            <button
              onClick={() => handlePageOptionChange("next")}
              disabled={
                pageOptions.pageNumber * pageOptions.pageSize >= totalRecords
              }
              className="btn btn-outline-primary px-3 mx-2"
            >
              <i className="bi bi-chevron-right"></i>
            </button>
          </div>
    </div>
  )
}

export default QuestionQuery